import { render, staticRenderFns } from "./InvoiceLogo.vue?vue&type=template&id=135b0d6f&"
import script from "./InvoiceLogo.vue?vue&type=script&lang=js&"
export * from "./InvoiceLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports